// extracted by mini-css-extract-plugin
export default {"galleryThumbnail":"c-l_eA","galleryThumbnail__image":"c-l_eB"};